"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var hoistNonReactStatics = require("hoist-non-react-statics");

var react_1 = __importDefault(require("react"));

var Field_1 = require("./Field");

var index_1 = require("./index");

function withField(InputComponent, fieldProps) {
  if (fieldProps === void 0) {
    fieldProps = {};
  }

  var _a;

  var WithField = (_a =
  /** @class */
  function (_super) {
    __extends(class_1, _super);

    function class_1() {
      var _this = _super !== null && _super.apply(this, arguments) || this;

      _this.renderInput = function (props) {
        var Inpt = InputComponent;
        return react_1.default.createElement(Inpt, __assign({
          status: props.hasError ? 'error' : undefined
        }, index_1.extractInputProps(_this.props), props.input));
      };

      return _this;
    }

    class_1.prototype.render = function () {
      return react_1.default.createElement(Field_1.Field, __assign({}, this.props, {
        render: this.renderInput
      }, fieldProps));
    };

    return class_1;
  }(react_1.default.Component), _a.displayName = "Field(" + (InputComponent.displayName || InputComponent.name) + ")", _a);
  hoistNonReactStatics(WithField, InputComponent);
  return WithField;
}

exports.withField = withField;